// extracted by mini-css-extract-plugin
export default {"take":"TakeRestHeight_take__2Dzm6"};